import { ColorPicker } from '@/components/ColorPicker';
import { isValidHexColor } from '@/components/ColorPicker/utils/isValidHexColor';
import { removeHexColorAlphaSuffix } from '@/components/ColorPicker/utils/removeHexColorAlphaSuffix';
import { predefinedColors } from '@/pages/AdvancedEditor/components/panels/common/predefinedColors';
import { useAdvancedEditorContext } from '@/pages/AdvancedEditor/context/useAdvancedEditorContext';
import { getAvatarElementFromPage } from '@/pages/AdvancedEditor/utils';
import theme from '@/theme';
import styled from '@emotion/styled';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';

const ColorPickerContainer = styled.div`
    display: flex;
    width: min-content;
    gap: 8px;
    align-items: center;
    cursor: pointer;
    border-radius: 8px;
    padding: 6px 8px;
    border: 1px solid ${theme.colors.black[200]};
`;

const InvisibleInput = styled.input`
    border: none;
    outline: none;
    width: auto;
    min-width: 0;
    flex: 0 1 auto;
    color: ${theme.colors.secondary.main};
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
`;

const DEFAULT_SHADOW_COLOR = '#000000';

export const ShadowColorControl = observer(() => {
    const { store } = useAdvancedEditorContext();
    const avatarElement = getAvatarElementFromPage(store.activePage);

    if (!avatarElement) return null;

    useEffect(() => {
        if (avatarElement.shadowColor === 'black') {
            return handleColorChange(DEFAULT_SHADOW_COLOR);
        }
    }, []);

    const handleColorChange = (color: string) => {
        const shadowColor = removeHexColorAlphaSuffix(color);
        avatarElement.set({ shadowColor });
    };

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const input = e.target.value.replaceAll('#', '');

        if (isValidHexColor(input)) {
            handleColorChange('#' + input);
        }
    };

    return (
        <ColorPickerContainer>
            <ColorPicker value={avatarElement.shadowColor} onChange={handleColorChange} size="24px" predefinedColors={predefinedColors} />
            <InvisibleInput
                size={8}
                type="text"
                value={avatarElement.shadowColor}
                onChange={handleInputChange}
                onClick={e => e.currentTarget.select()}
            />
        </ColorPickerContainer>
    );
});
